import { useTranslation } from 'react-i18next'

import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'

interface DeleteSurveyConfirmationPopupProps {
  onClose: VoidFunction
  onConfirm: () => Promise<void>
  surveyName: string
}

export const DeleteSurveyConfirmationPopup = ({
  onClose,
  onConfirm,
  surveyName,
}: DeleteSurveyConfirmationPopupProps) => {
  const { t } = useTranslation(['communication'])

  const handleConfirm = async () => {
    await onConfirm()
    onClose()
  }

  return (
    <ConfirmationPopup
      confirmText={t('communication:surveys.deleteConfirmation.confirm')}
      title={t('communication:surveys.deleteConfirmation.title')}
      variant="danger"
      onClose={onClose}
      onConfirm={handleConfirm}
    >
      <Typography>{t('communication:surveys.deleteConfirmation.body', { surveyName })}</Typography>
    </ConfirmationPopup>
  )
}
